import React from 'react'

export default function MarginLeft({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M13 4L11.5 4C10.3954 4 9.5 4.89543 9.5 6L9.5 14C9.5 15.1046 10.3954 16 11.5 16L13 16'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M6.5 7L6.5 13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
